/**
 * Scroll the page to the top after step navigation.
 * Uses instant scroll on multiple roots after layout paint — reliable on mobile Safari
 * when smooth scroll is cancelled by component unmount.
 */
export function scrollPageToTop() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  const scroll = () => {
    const roots = [
      window,
      document.scrollingElement,
      document.documentElement,
      document.body,
      document.getElementById('root'),
    ].filter(Boolean)

    roots.forEach((node) => {
      try {
        if (node.scrollTo) {
          node.scrollTo({ top: 0, left: 0, behavior: 'instant' })
        }
        if ('scrollTop' in node) {
          node.scrollTop = 0
        }
      } catch {
        // ignore
      }
    })
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(scroll)
  })
}
